module.exports = __webpack_public_path__ + "static/media/time.d178337b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/time.svg
// module id = 539
// module chunks = 32